import { queryOptions } from "@tanstack/react-query";
import { baseQueryOptions } from "@/core/hooks/useApiQueries/baseQueryOptions";
import { apiQueryFn } from "@/core/hooks/useApiQueries/useApiQuery";
import type { DocID, Sector } from "@/types";

/**
 * O setor como o shell lê: agente, plano com as features e o `follow_up_config`.
 *
 * Todo leitor de `["sectors", id]` usa ESTES params. Antes o `useSector` pedia
 * só o agente na mesma chave, e o último refetch ganhava: abrir a tela de
 * atendimento trocava o setor do shell por um sem `company.subscription.plan`.
 */
export const SECTOR_DETAIL_PARAMS: Record<string, string> = {
  "populate[agent][fields][0]": "active",
  "populate[agent][fields][1]": "name",
  "populate[company][populate][subscription][populate][plan][populate][features]":
    "*",
  "populate[company][populate][sectors][fields][0]": "documentId",
  "populate[follow_up_config]": "true",
};

export const sectorDetailQueryKey = (sectorId: DocID | null | undefined) =>
  ["sectors", sectorId] as const;

/** Setor ativo (provider), `useSector` e o pré-carregamento do boot (SA-1452). */
export const sectorDetailQueryOptions = (
  sectorId: DocID | null,
  token: string | null | undefined
) =>
  queryOptions({
    ...baseQueryOptions,
    queryKey: sectorDetailQueryKey(sectorId),
    queryFn: apiQueryFn<Sector>(
      token,
      "GET",
      sectorDetailQueryKey(sectorId),
      SECTOR_DETAIL_PARAMS
    ),
  });
